import { useTranslate } from '@/translations';
import { TranslationKey } from '@/translations/types';
import React from 'react';
import { Col, Descriptions } from 'antd';
import { CustomCard, LightBoxItem } from '@/ui/components';
import { ReplaceImageType } from '@/utils/constants';
import { TireGroup } from './types';
import { useAppCustomers } from '@/hooks';

export const TireCard = ({
  tireData,
  inspectionId,
  imageType,
}: {
  tireData: TireGroup;
  inspectionId: number;
  imageType: ReplaceImageType;
}) => {
  const { t } = useTranslate();
  const { hasSuperAdminAccess } = useAppCustomers();

  const ignoredKeys = ['imageFileUrl', 'thumbnailImageUrl'];

  return (
    <Col xs={12} md={8} lg={6} className="mb-3">
      <CustomCard direction="column">
        <Descriptions
          column={1}
          bordered
          size="small"
          className="no-border"
          items={Object.entries(tireData)
            .filter(([key]) => !ignoredKeys.includes(key))
            .map(([key, value]) => ({
              key,
              label: `${t(key as TranslationKey)}:`,
              children: value || t('notApplicable'),
            }))}
        />

        {tireData?.imageFileUrl ? (
          <LightBoxItem
            image={{
              replaceImage: { id: inspectionId, type: imageType },
              imageFileUrl: tireData.imageFileUrl,
              thumbnailImageUrl: tireData.thumbnailImageUrl,
            }}
            actions={{
              replaceImage: hasSuperAdminAccess ? () => {} : undefined,
            }}
          />
        ) : null}
      </CustomCard>
    </Col>
  );
};
